import { useCallback, useEffect, useRef, useState } from "react"

type ScrollBehavior = ScrollIntoViewOptions["behavior"]

export function useAtBottom(rootMargin = "0px 0px 80px 0px") {
  const scrollTargetRef = useRef<HTMLDivElement | null>(null)
  const [scrollTarget, setScrollTarget] = useState<HTMLDivElement | null>(null)
  const [isAtBottom, setIsAtBottom] = useState(true)

  const bottomRef = useCallback((node: HTMLDivElement | null) => {
    scrollTargetRef.current = node
    setScrollTarget(node)
  }, [])

  useEffect(() => {
    if (!scrollTarget) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsAtBottom(entry.isIntersecting)
      },
      { root: null, threshold: 0, rootMargin },
    )

    observer.observe(scrollTarget)
    return () => observer.disconnect()
  }, [scrollTarget, rootMargin])

  const scrollToBottom = useCallback((behavior: ScrollBehavior = "smooth") => {
    scrollTargetRef.current?.scrollIntoView({ behavior, block: "end" })
  }, [])

  return { bottomRef, isAtBottom, scrollToBottom }
}
